/*作为兄弟组件之间传值的交换机*/
import Vue from 'vue'

export default new Vue;



// WEBPACK FOOTER //
// ./src/eventBus/index.js